module.exports = __webpack_public_path__ + "img/03.e97dfad0.svg";